/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// const regEmail = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
export var validate = function (fields) {
    var isValid = true;
    fields.map(function (field) {
        if (field.rules) {
            field.rules.map(function (rule) {
                switch (rule) {
                    case 'CANNOT_BE_BLANK':
                        if (!field.value || field.value.length < 1) {
                            isValid = false;
                        }
                        break;
                    default:
                        break;
                }
            });
        }
    });
    return isValid;
};
export default validate;
//# sourceMappingURL=validation.js.map